// @flow
import { PersonsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    person: {},
    listaPersons: [],
    loading: false,
    error: false,
    formSubmited: false
};

type PersonsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { person?: {} | null, listaPersons?: [] | null, loading?: boolean, +value ?: boolean };

const Persons = (state: State = INIT_STATE, action: PersonsAction): any => {
    // console.log(action);
    switch (action.type) {
        case PersonsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case PersonsActionTypes.GET_PERSON: {
                    return {
                        ...state,
                        person: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case PersonsActionTypes.LIST_PERSONS: {
                    return {
                        ...state,
                        listaPersons: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case PersonsActionTypes.ADD_PERSON: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case PersonsActionTypes.UPDATE_PERSON: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case PersonsActionTypes.DELETE_PERSON: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PersonsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case PersonsActionTypes.GET_PERSON: {
                    return {
                        ...state,
                        error: action.payload.error,
                        person: {},
                        loading: false,
                    };
                }
                case PersonsActionTypes.LIST_PERSONS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaPersons: [],
                        loading: false,
                    };
                }
                case PersonsActionTypes.ADD_PERSON: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case PersonsActionTypes.UPDATE_PERSON: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case PersonsActionTypes.DELETE_PERSON: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PersonsActionTypes.GET_PERSON:
            return { ...state, error: false, loading: true };
        case PersonsActionTypes.LIST_PERSONS:
            return { ...state, error: false, loading: true };
        case PersonsActionTypes.ADD_PERSON:
            return { ...state, error: false, loading: true };
        case PersonsActionTypes.UPDATE_PERSON:
            return { ...state, error: false, loading: true };
        case PersonsActionTypes.DELETE_PERSON:
            return { ...state, error: false, loading: true };
        case PersonsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                person: {},
                listaPersons: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Persons;
